import React, { useCallback, useState } from 'react'
import { PowerMeterModel } from 'src/Libs/power-meters'
import { PowerMeterProviderContextProps } from './types'
import { PowerMeterProviderContext } from './context'

const PowerMeterProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [powerMetersInStorage, setPowerMetersInStorage] = useState<Map<string, PowerMeterModel[]>>(new Map())

  const setValues = useCallback(
    (storageSerialId: string, values: PowerMeterModel[]): void => {
      const newMap = new Map(Array.from(powerMetersInStorage.entries()))
      newMap.set(storageSerialId, values)
      setPowerMetersInStorage(newMap)
    },
    [powerMetersInStorage]
  )

  const providerValue = { values: powerMetersInStorage, setValues } as PowerMeterProviderContextProps

  return <PowerMeterProviderContext.Provider value={providerValue}>{children}</PowerMeterProviderContext.Provider>
}

export default PowerMeterProvider
